// extracted by mini-css-extract-plugin
module.exports = {"CardButton":"SecondryButton_CardButton__2GguU"};